import type { ImportCompletedPayload } from '../servicebus/import';
import { IMPORT_KIND, IMPORT_STATE } from '../import/import.interface';
import { ObjectFactory } from './object.factory';

export class ImportCompletedPayloadFactory extends ObjectFactory<ImportCompletedPayload> {
  protected getDefaults(): ImportCompletedPayload {
    return {
      fileName: 'orders.csv',
      importId: 'aabbccddeeff001122334455',
      kind: IMPORT_KIND.ORDERS,
      linesCount: {
        createError: 0,
        created: 3,
        parseError: 0,
        read: 3,
        skipped: 0,
        submitted: 3,
        total: 3,
        updateError: 0,
        updated: 0,
      },
      state: IMPORT_STATE.SUCCESS,
      userId: 'aabbccddeeff001122334456',
    };
  }
}

// Pre-instantiated for convenience
export const importCompletedPayloadFactory = new ImportCompletedPayloadFactory();
